export default "__VITE_ASSET__Db26UYAo__"